import { Star, Quote } from 'lucide-react';

const stats = [
  { number: '30+', label: 'År i branschen' },
  { number: '1000+', label: 'Genomförda projekt' },
  { number: '98%', label: 'Nöjda kunder' },
  { number: '24h', label: 'Svarstid på offert' },
];

const testimonials = [
  {
    name: 'Maria Lindström',
    location: 'Bromma',
    text: 'Fantastiskt arbete! Alla 12 fönster ser ut som nya. Teamet var professionella, punktliga och städade fint efter sig. Rekommenderas varmt!',
    rating: 5,
  },
  {
    name: 'Erik Johansson',
    location: 'Nacka',
    text: 'Mycket nöjd med både service och resultat. De tog sig tid att förklara processen och höll vad de lovade. Fast pris utan överraskningar.',
    rating: 5,
  },
  {
    name: 'Anna Bergström',
    location: 'Lidingö',
    text: 'Anlitade Vi Målar för att måla om alla fönster på vår BRF. Proffsigt utfört från start till slut. Smidigt samarbete och fin kommunikation.',
    rating: 5,
  },
];

export const SocialProofSection = () => {
  return (
    <section id="social-proof" className="section-padding bg-white" data-testid="social-proof-section">
      <div className="container-custom">
        {/* Stats bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 bg-[#F1F5F9] animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`stat-${index}`}
            >
              <div className="stat-number">{stat.number}</div>
              <div className="text-[#64748B] font-medium mt-2">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#C0392B] font-medium text-sm uppercase tracking-wider mb-4 block">
            Kundrecensioner
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-[#1F2937] mb-6">
            Vad våra kunder säger
          </h2>
          <p className="text-base md:text-lg text-[#64748B]">
            Vi är stolta över det förtroende våra kunder visar oss. Läs vad de tycker 
            om samarbetet och resultatet.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card animate-fade-in-up"
              style={{ animationDelay: `${index * 150}ms` }}
              data-testid={`testimonial-${index}`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4 relative z-10">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#F59E0B] text-[#F59E0B]" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-[#1F2937] mb-6 relative z-10 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="relative z-10">
                <div className="font-semibold text-[#1F2937]">{testimonial.name}</div>
                <div className="text-sm text-[#64748B]">{testimonial.location}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-16 text-center">
          <p className="text-[#64748B] mb-6">Betrodd partner på</p>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
            <div className="px-6 py-3 bg-[#F1F5F9] text-[#2C3E50] font-semibold">
              Offerta
            </div>
            <div className="px-6 py-3 bg-[#F1F5F9] text-[#2C3E50] font-semibold">
              Google Reviews
            </div>
            <div className="px-6 py-3 bg-[#F1F5F9] text-[#2C3E50] font-semibold">
              Reco.se
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
